// analytics/queryKeys.ts
import { createQueryKeys } from "@lukemorales/query-key-factory"

import { GetTimeSpentAnalyticsUrlParams } from "./urls"

interface GetTimeSpentAnalyticsUrlParamsExtended
  extends GetTimeSpentAnalyticsUrlParams {
  interval: string
  term?: string
}

export default createQueryKeys("analytics", {
  getLearnerAnalytics: (
    learningItemId: number | string,
    learningItemType: string,
    term?: string
  ) => ({
    queryKey: ["analytics", learningItemId, learningItemType, term],
  }),

  getTimeSpentAnalyticsQueryKey: ({
    itemId,
    itemType,
    interval,
    term,
  }: GetTimeSpentAnalyticsUrlParamsExtended) => ({
    queryKey: ["time-spent", itemId, itemType, interval, term],
  }),
})
